import React from 'react';
import { Skeleton } from './Skeleton';

/**
 * Skeleton Stat Card - for KPI/metric cards
 * Matches the StatCard component layout
 */
export const SkeletonStatCard = ({ className = '' }) => {
  return (
    <div
      className={`skeleton-stat-card ${className}`}
      style={{
        backgroundColor: 'var(--color-surface, #fff)',
        padding: '1.5rem',
        borderRadius: '0.75rem',
        border: '1px solid #e2e8f0'
      }}
    >
      {/* Icon placeholder */}
      <div style={{ marginBottom: '1rem' }}>
        <Skeleton
          width="48px"
          height="48px"
          borderRadius="12px"
        />
      </div>

      {/* Value */}
      <Skeleton
        width="60%"
        height="2rem"
        style={{ marginBottom: '0.5rem' }}
      />

      {/* Label */}
      <Skeleton
        width="80%"
        height="1rem"
      />
    </div>
  );
};

/**
 * Skeleton Stats Grid - for multiple stat cards
 */
export const SkeletonStatsGrid = ({
  count = 4,
  columns = 4,
  className = ''
}) => {
  return (
    <div
      className={`skeleton-stats-grid ${className}`}
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(240px, 100%), 1fr))',
        gap: '1.5rem'
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonStatCard key={`stat-${index}`} />
      ))}
    </div>
  );
};

/**
 * Skeleton Mobile Stat Card - for mobile stat display
 */
export const SkeletonMobileStatCard = ({ className = '' }) => {
  return (
    <div
      className={`skeleton-mobile-stat-card ${className}`}
      style={{
        backgroundColor: 'var(--color-surface, #fff)',
        padding: '1rem',
        borderRadius: '0.75rem',
        border: '1px solid #e2e8f0',
        minWidth: '160px'
      }}
    >
      <Skeleton
        width="50%"
        height="1.5rem"
        style={{ marginBottom: '0.5rem' }}
      />
      <Skeleton
        width="70%"
        height="0.875rem"
      />
    </div>
  );
};

/**
 * Skeleton Mobile Stats Container - horizontal scroll
 */
export const SkeletonMobileStatsContainer = ({
  count = 3,
  className = ''
}) => {
  return (
    <div
      className={`skeleton-mobile-stats-container ${className}`}
      style={{
        display: 'flex',
        gap: '1rem',
        overflowX: 'auto',
        padding: '0.5rem 0'
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonMobileStatCard key={`mobile-stat-${index}`} />
      ))}
    </div>
  );
};

export default SkeletonStatCard;
